import { flow, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import { PaginationModel } from "../share/PagingModel";
import { IPlanHeaderModel, PlanHeaderModel } from "../share/PlanModel";
import financialReportAPI from "./FinancialReportService";
import { ShareHolderModel } from "../org/OrganizeModel";

export const FinancialReportListModel = types
  .model("FinancialReportListModel", {
    planStatus: customtypes.optional(types.string, ""),
    planRelease: customtypes.optional(types.string, ""),
    year: types.optional(types.number, 0),
    list: customtypes.optional(types.array(PlanHeaderModel), []),
    paging: customtypes.optional(PaginationModel, {}),
    organizationID: types.maybe(types.number),
    organization: types.optional(ShareHolderModel, {}), //  ShareHolderModel เพราะต้องใช้กับ OrganizationDropdown
    error: customtypes.optional(ErrorModel, {}),
    loading: types.optional(types.boolean, false),
  })
  .views((self: any) => ({
    get options() {
      return self.list.map((item: IPlanHeaderModel) => {
        return {
          key: item.planID,
          text: item.description,
          value: item.planID,
        };
      });
    },
  }))
  .actions((self: any) => ({
    getFinancialReportList: flow(function* () {
      try {
        self.loading = true;
        const result = yield financialReportAPI.getFinancialReportList({
          organizationID: self.organizationID || null,
          planStatus: self.planStatus,
          planRelease: self.planRelease,
          year: self.year || null,
          paging: self.paging,
        });
        self.list = result.data;
        self.setPagination(result);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    printFinancialReport: flow(function* (id: number) {
      try {
        self.loading = true;
        yield financialReportAPI.printFinancialReport(id);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
        self.loading = false;
      }
    }),
    removeFinancialReport: flow(function* (planID: number) {
      try {
        self.loading = true;
        const result = yield financialReportAPI.removeFinancialReport(planID);
        // console.log("removeFinancialReport", result);
        // self.setAllField(result.data);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    onSelectedFilter: (value: any) => {
      self.setDefaultPagination();
      self.planStatus = value;
      self.getFinancialReportList();
    },
    setPagination: (result: any) => {
      self.paging.pageSize = result.pageSize;
      self.paging.pageNo = result.pageNo;
      self.paging.totalRow = result.totalRow;
    },
    onSelectedPage: (pageNo: number) => {
      self.paging.pageNo = pageNo;
      self.getFinancialReportList();
    },
    onSearchTextFilter: (value: any) => {
      self.setDefaultPagination();
      self.paging.searchText = value;
      self.getFinancialReportList();
    },
    setDefaultPagination: () => {
      self.paging.pageNo = 1;
    },
    resetAll: () => {
      self.list = [];
      self.paging = {};
    },
  }));

export type IFinancialReportListModel = typeof FinancialReportListModel.Type;
